window.MaterikModelSelection = class MaterikModelSelection {
  static create(host) {
    if (!host.dataset.materikModelPosition) return null;
    return new this(host);
  }

  constructor(host) {
    this.host = host;
    this.position = Number(host.dataset.materikModelPosition) - 1;
    this.model = null;
    this.variant = null;
    this.pending = false;
    this.nativeAvailable = false;
    this.summary = host.querySelector('[data-model-summary]');
    this.guard = (event) => {
      if (this.canPurchase()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.field()?.querySelector('input')?.focus();
    };
    host.addEventListener('submit', this.guard, true);
    this.pageShow = (event) => {
      if (event.persisted) this.failed();
    };
    window.addEventListener('pageshow', this.pageShow);
    this.restorePicker(host);
    this.render();
  }

  field(root = this.host) {
    return root.querySelector('variant-selects:not([style*="display: none"]) [data-materik-model-option]');
  }

  optionValues() {
    const picker = this.field()?.closest('variant-selects');
    if (!picker) return null;
    return [...picker.querySelectorAll('fieldset, .product-form__input--dropdown')]
      .map((group) => {
        const selected = group.querySelector('input:checked, select option:checked');
        return selected?.dataset.optionValueId || group.dataset.modelDefaultOptionValue;
      })
      .filter(Boolean);
  }

  change(target) {
    if (target.closest('[data-materik-model-option]')) this.model = target.value;
    this.pending = true;
    this.render();
  }

  matches(variant = this.variant) {
    return !!this.model && variant?.options?.[this.position] === this.model;
  }

  canPurchase() {
    const input = this.host.querySelector('product-form input[name="id"]');
    return !this.pending && this.nativeAvailable && this.matches() &&
      this.variant?.available === true && String(input?.value) === String(this.variant.id);
  }

  restorePicker(root) {
    this.field(root)?.querySelectorAll('input[type="radio"]').forEach((input) => {
      const selected = input.value === this.model;
      input.checked = selected;
      input.toggleAttribute('checked', selected);
    });
  }

  prepare(html, variant) {
    this.restorePicker(html);
    const button = html.getElementById(`ProductSubmitButton-${this.host.sectionId}`);
    this.nativeAvailable = button?.dataset.modelNativeDisabled === 'false';
    button?.toggleAttribute('disabled', !(this.nativeAvailable && this.matches(variant)));
  }

  resolve(variant) {
    this.pending = false;
    this.variant = variant;
    this.restorePicker(this.host);
    this.render();
  }

  failed() {
    this.pending = false;
    this.model = null;
    this.nativeAvailable = false;
    this.restorePicker(this.host);
    this.render();
  }

  render() {
    if (!this.summary) return;
    const ready = this.canPurchase();
    this.host.dataset.modelReady = String(ready);
    const button = this.host.querySelector('product-form [name="add"]');
    if (button) {
      button.disabled = !ready;
      if (this.pending) button.querySelector('span').textContent = this.summary.dataset.loadingLabel;
      else if (!this.model) button.querySelector('span').textContent = this.summary.dataset.selectLabel;
      else if (ready) button.querySelector('span').textContent = window.variantStrings.addToCart;
    }
    const payments = this.host.querySelector('[data-model-payments]');
    if (payments) {
      payments.hidden = !ready;
      payments.toggleAttribute('inert', !ready);
    }
    const model = this.summary.querySelector('[data-model-summary-value]');
    model.textContent = this.model || this.summary.dataset.chooseLabel;
    model.classList.toggle('mk-model-selection__empty', !this.model);
    const colors = this.field()?.closest('variant-selects')?.querySelectorAll('input:checked, select option:checked');
    this.summary.querySelector('[data-model-summary-color]').textContent = [...(colors || [])]
      .filter((input) => !input.closest('[data-materik-model-option]'))
      .map((input) => (input.dataset.displayValue || input.value).trim()).join(' / ');
    const hint = this.host.querySelector('[data-model-hint]');
    if (hint) hint.textContent = this.model
      ? this.summary.dataset.selectedTemplate.replace('__model__', this.model)
      : this.summary.dataset.hintLabel;
  }

  disconnect() {
    this.host.removeEventListener('submit', this.guard, true);
    window.removeEventListener('pageshow', this.pageShow);
  }
};
